// extracted by mini-css-extract-plugin
export default {"dialog":"common-components-ErrorDialog-ErrorDialog__dialog--hHu4T","message":"common-components-ErrorDialog-ErrorDialog__message--O6jNg"};